import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// RU translations
import commonRu from './locales/ru/common.json';
import authRu from './locales/ru/auth.json';
import dashboardRu from './locales/ru/dashboard.json';
import marketAnalysisRu from './locales/ru/market-analysis.json';
import personasRu from './locales/ru/personas.json';
import researchRu from './locales/ru/research.json';
import positioningRu from './locales/ru/positioning.json';
import businessModelRu from './locales/ru/business-model.json';
import financialModelRu from './locales/ru/financial-model.json';
import marketingStrategyRu from './locales/ru/marketing-strategy.json';
import mvpPlanRu from './locales/ru/mvp-plan.json';
import methodologiesRu from './locales/ru/methodologies.json';
import chatRu from './locales/ru/chat.json';
import subscriptionRu from './locales/ru/subscription.json';
import profileRu from './locales/ru/profile.json';
import helpRu from './locales/ru/help.json';
import feedbackRu from './locales/ru/feedback.json';
import builderRu from './locales/ru/builder.json';
import siteAuditRu from './locales/ru/siteAudit.json';
import toolsRu from './locales/ru/tools.json';

// EN translations
import commonEn from './locales/en/common.json';
import authEn from './locales/en/auth.json';
import dashboardEn from './locales/en/dashboard.json';
import marketAnalysisEn from './locales/en/market-analysis.json';
import personasEn from './locales/en/personas.json';
import researchEn from './locales/en/research.json';
import positioningEn from './locales/en/positioning.json';
import businessModelEn from './locales/en/business-model.json';
import financialModelEn from './locales/en/financial-model.json';
import marketingStrategyEn from './locales/en/marketing-strategy.json';
import mvpPlanEn from './locales/en/mvp-plan.json';
import methodologiesEn from './locales/en/methodologies.json';
import chatEn from './locales/en/chat.json';
import subscriptionEn from './locales/en/subscription.json';
import profileEn from './locales/en/profile.json';
import helpEn from './locales/en/help.json';
import feedbackEn from './locales/en/feedback.json';
import builderEn from './locales/en/builder.json';
import siteAuditEn from './locales/en/siteAudit.json';
import toolsEn from './locales/en/tools.json';

const pathLanguageDetector = {
  name: 'pathDetector',
  lookup() {
    const path = window.location.pathname;
    if (path.startsWith('/en/') || path === '/en') {
      return 'en';
    }
    return 'ru';
  },
};

const languageDetectorInstance = new LanguageDetector();
languageDetectorInstance.addDetector(pathLanguageDetector);

i18n
  .use(languageDetectorInstance)
  .use(initReactI18next)
  .init({
    resources: {
      ru: {
        common: commonRu,
        auth: authRu,
        dashboard: dashboardRu,
        'market-analysis': marketAnalysisRu,
        personas: personasRu,
        research: researchRu,
        positioning: positioningRu,
        'business-model': businessModelRu,
        'financial-model': financialModelRu,
        'marketing-strategy': marketingStrategyRu,
        'mvp-plan': mvpPlanRu,
        methodologies: methodologiesRu,
        chat: chatRu,
        subscription: subscriptionRu,
        profile: profileRu,
        help: helpRu,
        feedback: feedbackRu,
        builder: builderRu,
        siteAudit: siteAuditRu,
        tools: toolsRu,
      },
      en: {
        common: commonEn,
        auth: authEn,
        dashboard: dashboardEn,
        'market-analysis': marketAnalysisEn,
        personas: personasEn,
        research: researchEn,
        positioning: positioningEn,
        'business-model': businessModelEn,
        'financial-model': financialModelEn,
        'marketing-strategy': marketingStrategyEn,
        'mvp-plan': mvpPlanEn,
        methodologies: methodologiesEn,
        chat: chatEn,
        subscription: subscriptionEn,
        profile: profileEn,
        help: helpEn,
        feedback: feedbackEn,
        builder: builderEn,
        siteAudit: siteAuditEn,
        tools: toolsEn,
      },
    },
    detection: {
      order: ['pathDetector', 'localStorage'],
      lookupLocalStorage: 'creator-lang',
      caches: ['localStorage'],
    },
    fallbackLng: 'ru',
    defaultNS: 'common',
    ns: [
      'common', 'auth', 'dashboard', 'market-analysis', 'personas',
      'research', 'positioning', 'business-model', 'financial-model',
      'marketing-strategy', 'mvp-plan', 'methodologies', 'chat', 'subscription', 'profile', 'help', 'feedback',
    ],
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export default i18n;
